import React, { useEffect, useRef } from "react";
import Link from "next/link";

const NavBottom = ({
  activeCategory,
  setActiveCategory,
  setExpandableArea,
  category,
  onMouseLeave,
}: {
  activeCategory: string | null;
  setActiveCategory: (category: string) => void;
  setExpandableArea: (height: number) => void;
  category: Array<{
    title: string;
    slug: string;
    subcategory_detail: Array<{ title: string; slug: string }>;
  }>;
  onMouseLeave: () => void;
}) => {
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current) {
      const height = contentRef.current.scrollHeight;
      setExpandableArea(height + 100);
    }
  }, [activeCategory, setExpandableArea]);

  if (!activeCategory) {
    return null;
  }

  return (
    <div
      ref={contentRef}
      onMouseLeave={onMouseLeave}
      className="grid grid-cols-12 gap-6 pb-4 pt-6"
    >
      <div className="col-span-2">
        <div className="pr-4">
          <h3 className="mb-4 text-xs font-semibold text-gray-500">
            Categories
          </h3>
          <nav className="flex flex-col space-y-1">
            {category.map((cat) => (
              <button
                key={cat.slug}
                onClick={() => setActiveCategory(cat.title)}
                className={`rounded-md px-3 py-2 text-left text-sm font-medium transition-colors duration-200 ${
                  activeCategory === cat.title
                    ? "bg-[#f0f4ff] text-[#6049E7]"
                    : "text-gray-700 hover:bg-gray-100"
                }`}
              >
                <div className="flex items-center justify-between">
                  <span>{cat.title}</span>
                  {activeCategory === cat.title && (
                    <svg
                      className="ml-2 h-4 w-4 text-[#6049E7]"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  )}
                </div>
              </button>
            ))}
          </nav>
        </div>
      </div>
      <div className="col-span-10">
        <h3 className="mb-4 text-xs font-semibold text-gray-500">
          {activeCategory} Topics
        </h3>
        <div className="grid grid-cols-4 gap-3">
          {category
            .find((cat) => cat.title === activeCategory)
            ?.subcategory_detail.map((subcategory) => (
              <Link
                key={subcategory.slug}
                href={`/blog/${subcategory.slug}`}
                className="group rounded-lg border border-[#EAECF0] bg-[#f9fafb] px-3 py-2.5 transition-colors duration-200 hover:bg-[#f0f4ff]"
              >
                <div className="flex flex-col">
                  <span className="text-sm font-medium text-gray-900">
                    {subcategory.title}
                  </span>
                </div>
              </Link>
            ))}
        </div>
      </div>
    </div>
  );
};

export default NavBottom;
